'use strict';

import * as Onyx from '../../lib/onyx.min.js';

export default class SceneTitle extends Onyx.Scene {
    constructor(){
        super({
            template: '@@import routes/title/index.html',
            clock: new Onyx.Clock()
        });
    }

    onload(){
        super.onload();

        // Hide Build Date Warning
        document.getElementById('build-date-warning').style.display = 'none';

		document.getElementById("student-name").innerHTML = document.getElementById("student-name").innerHTML.replace("${centralStation.player.first_name}", centralStation.player.first_name);
		document.getElementById("student-name").innerHTML = document.getElementById("student-name").innerHTML.replace("${centralStation.player.last_name}", centralStation.player.last_name);
    }

    @Onyx.handles('click') //, {elementId: 'start'}
    play(){ 
        game.showLoadingMask();

        // Unlock TTS on iOS
        window.centralStation.TTSSpeak("");

        this.setTimeout(() => {
            this.clock.stop();

            // window.setTimeout(function(){ // Give the browser a second to breathe and cleanup and garbage
                router.navigate("character-select"); 
            // }, 1000);
        }, 1000);
        
        // game.sfx["sndButtonPress"].play();
    }

    update(...args){
        super.update(...args);

        if(this.player) this.player.transform.z--;
    }
}